import { call, put, take, select } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import SponsorActions from '../reducers/sponsorReducer'
import firebase from '../config/firebase'

const observerEvent = ref => {
  const listener = eventChannel(emit => {
    ref.on('value', data => {
      if (data.val() !== null) {
        const sponsors = {}

        data.forEach((res) => { sponsors[res.key] = res.val() })

        emit(sponsors)
      } else {
        emit({})
      }
    })

    return () => {
      ref.off()
    }
  });

  return listener
};

export function* getSponsors() {
  const { region } = yield select(state => state.auth.data)
  const database = firebase.database()
  const sponsorsConnectionRef = database.ref('sponsors').orderByChild('region').equalTo(region)
  const databaseEventChannel = yield call(observerEvent, sponsorsConnectionRef) // listening databaseEvent

  try {
    while (true) {
      const sponsors = yield take(databaseEventChannel) // take event data

      yield put(SponsorActions.getSponsorsConnected(sponsors))
    }
  } catch(error) {
      yield put(SponsorActions.getSponsorsError(error))
  } finally {
    databaseEventChannel.close();
  }
}





// WEBPACK FOOTER //
// ./src/sagas/sponsorSaga.js